// extracted by mini-css-extract-plugin
module.exports = {"button":"AppButton_button__fPw66"};